import gql from "graphql-tag";

export const GET_APPROVAL_STATE = gql`
  query getApprovalState {
    getApprovalState {
      acknowledgedAt
      acknowledgedBy
      approvedAt
      approvedBy
      isAcknowledged
      isApproved
      lastModificationDate
    }
  }
`;
